import { render, staticRenderFns } from "./ProductsDemoComp.vue?vue&type=template&id=28c4c7a6&scoped=true&"
import script from "./ProductsDemoComp.vue?vue&type=script&lang=js&"
export * from "./ProductsDemoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4c7a6",
  null
  
)

export default component.exports